<template>
  <div class="curriculum" v-loading="loading">
    <div class="content">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item index="0">当前课程</el-menu-item>
        <el-menu-item index="1">历史课程</el-menu-item>
      </el-menu>
      <el-card
        class="card-box"
        :class="{ 'card-box--upcoming': i.status === 0 }"
        v-for="(i, _i) in list"
        :key="_i"
        @click="into(i)"
        v-show="i.showStatus == activeIndex"
      >
        <div class="pic">
          <img :src="courseCoverUrl(i.coverFile)" alt="" />
        </div>
        <div class="detail">
          <div class="title">
            {{ i.title }}
            <span
              v-if="i.status === 0"
              class="course-status course-status--upcoming"
            >
              未开始
            </span>
          </div>
          <div class="progress">学习进度：{{ i.progress }}%</div>
          <div
            v-if="i.courseUsesDualQuota"
            class="class-hours class-hours--dual"
          >
            总学时：必修课时 {{ formatListHours(i.requiredClassHours) }} h +
            选修课时 {{ formatListHours(i.electiveTargetClassHours) }} h
          </div>
          <div v-else-if="i.totalClassHours" class="class-hours">
            总要求课时：{{ i.totalClassHours }} h
          </div>
          <div v-if="i.startTime && i.endTime" class="date">
            课程时间：{{ i.startTime }} ~ {{ i.endTime }}
          </div>
        </div>
      </el-card>
      <div class="empty" v-if="!list.length && !loading">您暂无课程</div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { joinFileUrl } from "../../../utils/fileUrl.cjs";

export default {
  name: "curriculum",
  data() {
    return {
      activeIndex: 0,
      loading: true,
      totalList: [],
      list: [],
    };
  },
  methods: {
    courseCoverUrl(path) {
      return joinFileUrl(this.$domainName, path);
    },
    formatListHours(v) {
      if (v == null || v === "") return "—";
      const n = Number(v);
      return Number.isFinite(n) ? n.toFixed(1) : "—";
    },
    handleSelect(key) {
      this.activeIndex = Number(key);
      this.list = this.totalList.filter(
        (el) => el.showStatus == this.activeIndex
      );
    },
    initData() {
      this.$https.get("/api/my/course/list").then((res) => {
        if (res.success) {
          const data = res.data;
          this.totalList = data.map((el) => {
            return {
              ...el,
              endTime: moment(el.endTime).format("YYYY-MM-DD"),
              startTime: moment(el.startTime).format("YYYY-MM-DD"),
              status: juedeStatus(el),
              showStatus: juedeStatus(el) < 2 ? 0 : 1,
              progress: Number(el.progress ?? 0).toFixed(2),
            };
          });
          this.list = this.totalList.filter(
            (el) => el.showStatus == this.activeIndex
          );
        }
        this.loading = false;

        // 判断课程状态，0未开始，1已经开始，2过期
        function juedeStatus(item) {
          const currentTime = moment().valueOf();
          let status;
          if (currentTime < item.startTime) {
            status = 0;
          }
          if (currentTime >= item.startTime && currentTime <= item.endTime) {
            status = 1;
          }
          if (currentTime > item.endTime) {
            status = 2;
          }
          return status;
        }
      });
    },
    into(item) {
      if (item.status === 0) {
        this.$message.info(`课程将于 ${item.startTime} 开始`);
        return;
      }
      if (item.status === 2) {
        this.$message.error("课程已过期");
        return;
      }
      window.open("/curriculumDetails?id=" + item.id);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
<style lang="less">
.curriculum {
  position: relative;
  text-align: center;
  padding: 2% 0;
  .content {
    display: inline-block;
    width: 90%;
    text-align: left;
    .card-box {
      width: 23%;
      margin: 1%;
      display: inline-block;
      text-align: left;
      border-radius: 5px;
      cursor: pointer;
      &.card-box--upcoming {
        cursor: not-allowed;
        opacity: 0.82;
      }
      .pic {
        height: 200px;
        img {
          width: 100%;
          height: 200px;
          object-fit: contain;
        }
      }
      .detail {
        padding: 10px;
        line-height: 1.5;
        .title {
          font-size: 14px;
          font-weight: bold;
          color: #677897;
          .course-status--upcoming {
            display: inline-flex;
            margin-left: 10px;
            padding: 2px 8px;
            border-radius: 10px;
            color: #8a5a00;
            background: #fff4d6;
            font-size: 12px;
          }
        }
        .progress {
          font-size: 12px;
          color: #b0b9ca;
        }
        .class-hours {
          font-size: 12px;
          color: #909399;
        }
        .date {
          font-size: 14px;
          color: #67c23a;
        }
      }
    }
  }
}
</style>
